module.exports = __webpack_public_path__ + "img/Gaz_de_Bordeaux_120X35.26714735.png";